module.exports = "/assets/data/6546f16140b26b9608812b71d303ddb4-GU10.data.json";